export default __webpack_public_path__ + "static/media/InactiveFacebook.9293ba02.svg";